import { useSelector } from "react-redux";

export const useBetaPictureTakingEnabled = (): boolean => {
  const value = useSelector((state: any) => state?.auth?.betaPictureTakingEnabled);
  return value == null
    ? localStorage.getItem("betaPictureTakingEnabled") === "true"
    : value === true;
};
